var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex flex-row",attrs:{"aria-hidden":"true"}},[_c('span',{staticClass:"flex-center",style:({
      width: _vm.S.colCount,
      paddingBottom: '2px',
      borderBottom: '1px solid ' + _vm.T.panel.border,
      color: _vm.T.text.iconSoft,
    }),attrs:{"title":_vm.label}},[_c('ga-icon',{style:({ width: _vm.S.iconSm, height: _vm.S.iconSm }),attrs:{"name":_vm.icon,"stroke":2.25}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }